import Modal from '../../../components/Modal';
import { useModal } from '../../../hooks/useModal';
import Button from '../../../components/Button';
import { formShell } from '../../../styles/formShell';

export function ActionButtons({ onLogout }) {
    const { isOpen, openModal, closeModal } = useModal();

    const handleLogoutClick = () => {
        openModal();
    };

    const handleConfirmLogout = () => {
        closeModal();
        onLogout();
    };

    return (
        <>
            <div className={formShell.actions}>
                <Button
                    variant="danger"
                    size="cta"
                    onClick={handleLogoutClick}
                    className="w-full min-w-0 bp-lg:w-auto bp-lg:min-w-40"
                >
                    <span className="material-symbols-outlined">
                        logout
                    </span>
                    ログアウト
                </Button>
            </div>
            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title="ログアウトしますか？"
                size="small"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    { label: "ログアウト", variant: "danger", onClick: handleConfirmLogout }
                ]}
            >
                {/* <p>本当にログアウトしますか？</p> */}
            </Modal>
        </>
    );
}
